import { push } from 'connected-react-router';
import { of } from 'rxjs/observable/of';
import ooeConstants from '../constants';
import { types as guestTypes, selectApiKey } from '../reducers/guest';
import {
  actions as orderActions,
  types as orderTypes,
  selectOrder,
  selectOrderForAmplitude,
  selectOrderForDXE,
} from '../reducers/order';
import { selectPaymentForDXE } from '../reducers/payment';
import { logAmplitudeEvent } from '../services/amplitude';
import { getOrder, lookupLocationsByNumber, resubmitOrder, submitOrder } from '../services/orderApi';
import { getHash } from '../util/location';

export const GetOrder = (action$, store) =>
  action$
    .ofType(guestTypes.GET_GUEST_SESSION_SUCCESS)
    .map(getHash)
    .filter((hash) => hash.id_token && hash.id_token.length > 0)
    .switchMap((hash) => {
      const state = store.getState();
      const apiKey = selectApiKey(state);

      // TODO consider getting this through state so we can remove hash from url
      const token = hash.id_token;
      const payload = JSON.parse(atob(token.split('.')[1]));
      return getOrder(apiKey, payload.orderId)
        .map(orderActions.getOrderSuccess)
        .catch((err) => of(orderActions.getOrderFailure(err)));
    });

export const SubmittedOrder = (action$) =>
  action$
    .ofType(orderTypes.GET_ORDER_SUCCESS)
    .filter((action) => action.order.status === ooeConstants.ORDER_STATUS.Submit)
    .map(() =>
      push({
        pathname: '/review',
      }),
    );

export const GetLocation = (action$, store) =>
  action$
    .ofType(guestTypes.GET_GUEST_SESSION_SUCCESS)
    .map(getHash)
    .filter((hash) => hash.id_token && hash.id_token.length > 0)
    .switchMap((hash) => {
      const state = store.getState();
      const apiKey = selectApiKey(state);
      const token = hash.id_token;
      const payload = JSON.parse(atob(token.split('.')[1]));
      const { locationNumber } = payload;
      return lookupLocationsByNumber(locationNumber, apiKey)
        .map(orderActions.getLocationSuccess)
        .catch((err) => of(orderActions.getLocationFailure(err)));
    });

export const FatalError = (action$) =>
  action$.ofType(orderTypes.FATAL_ERROR).map(() =>
    push({
      pathname: '/error',
    }),
  );

export const AddDeliveryTip = (action$, store) =>
  action$.ofType(orderTypes.ADD_DELIVERY_TIP).switchMap(({ deliveryTipType, deliveryTipValue }) => {
    const state = store.getState();
    const order = selectOrder(state);
    const deliveryTip = {
      [deliveryTipType]: +deliveryTipValue,
    };
    const orderToPost = {
      ...order,
      deliveryTip,
    };
    return of(orderToPost)
      .map(orderActions.addDeliveryTipSuccess)
      .catch((err) => of(orderActions.addDeliveryTipFailure(err)));
  });

export const SubmitOrder = (action$, store) =>
  action$.ofType(orderTypes.SUBMIT_ORDER).switchMap(() => {
    const state = store.getState();
    const orderForDXE = selectOrderForDXE(state);
    const payment = selectPaymentForDXE(state);
    const orderForAmplitude = selectOrderForAmplitude(state);
    const apiKey = selectApiKey(state);
    const orderToPost = {
      ...orderForDXE,
      payment,
    };

    logAmplitudeEvent('[My Payment] Submit Order', {
      order: {
        ...orderForAmplitude,
        paymentType: 'NewPayment',
      },
    });
    return submitOrder(apiKey, orderToPost)
      .map(orderActions.submitOrderSuccess)
      .catch((err) => of(orderActions.submitOrderFailure(err)));
  });

export const ReSubmitOrder = (action$, store) =>
  action$.ofType(orderTypes.RESUBMIT_ORDER).switchMap(() => {
    const state = store.getState();
    const order = selectOrder(state);
    const orderForAmplitude = selectOrderForAmplitude(state);
    const apiKey = selectApiKey(state);
    const paymentType = order.payment?.paymentType === 'TO_BE_COLLECTED' ? 'PayLater' : 'StoredPayment';

    logAmplitudeEvent('[My Payment] Submit Order', {
      order: {
        ...orderForAmplitude,
        paymentType,
      },
    });
    return resubmitOrder(apiKey, order)
      .map(orderActions.submitOrderSuccess)
      .catch((err) => of(orderActions.submitOrderFailure(err)));
  });

export const GoToSuccessPage = (action$) =>
  action$.ofType(orderTypes.SUBMIT_ORDER_SUCCESS).map(() => push({ pathname: '/success' }));

export default [
  GetOrder,
  SubmittedOrder,
  GetLocation,
  FatalError,
  SubmitOrder,
  GoToSuccessPage,
  AddDeliveryTip,
  ReSubmitOrder,
];
